import "./entry.less";
import Vue from 'vue';
import Vuex from 'vuex';
import storeConfig from 'components/pagesbuilder/store/store-config';
import PreviewComponentsManager from 'pages/dynamic-components/PreviewComponentsManager.vue';
import PreviewSectionsManager from 'pages/sections/PreviewSectionsManager.vue';
import CommonMain from 'components/pagesbuilder/CommonMain';
import PreviewElementsManager from "pages/elements/PreviewElementsManager";
import AdminNavigationTooltip from "pages/components/AdminNavigationTooltip";
import eventBus from '../commonjs/EventBus.vue';
import {mapActions,mapState} from 'vuex';
import Notifications from "pages/components/Notifications";
import PopupNotifications from "pages/components/PopupNotifications";
import PreviewModeNotification from "pages/components/PreviewModeNotification";
window.addEventListener('DOMContentLoaded', (event) => {    
    // Setup vue instance
    window.pageBuilder = new Vue({
        el : "#pageTools",
        store: new Vuex.Store(storeConfig),
        mixins: [CommonMain,Notifications],
        computed: {
            ...mapState('UiInteractions', [
                'activeDevicePreview',
                'availableDevicePreviews',
            ]),
            ...mapState('siteTemplate', [
                'responsiveFontScale'
            ]),
            deviceBreakpoints: function () {
                const breakPoints = {};
                for (let device in this.availableDevicePreviews) {
                    if (device !== 'desktop' && typeof this.availableDevicePreviews[device]['mediaQuery'] === 'object') {
                        breakPoints[device] = this.availableDevicePreviews[device]['mediaQuery'];
                    }
                }
                return breakPoints;
            }
        },
        mounted () {
            this.initNotificationsInterval();
        },
        methods: {
            ...mapActions('topbar',[
                'setSchoolTopbarData'
            ]),
            ...mapActions('footer',[
                'setSchoolFooterData'
            ]),
            ...mapActions('user',[
                'setUnreadInboxMessages'
            ]),
            init () {
                let pageWrapper = document.body;
                //load products to setup store and interface editing tools
                let initActions = [];

                initActions.push(this.loadProducts());
                // initActions.push(this.getArticles());
                initActions.push(this.setSchoolTopbarData(window.globalTopbar));
                initActions.push(this.setSchoolFooterData(window.globalFooter));
                initActions.push(this.initializePageData(window.pageState));

                Promise.all(initActions).then(()=>{
                    //State sections should be initiated before the component & element states
                    this.initSectionsManager(pageWrapper);
                    // this.$nextTick(()=>{
                        this.initComponentsManager(pageWrapper);
                        this.initElementsManager(pageWrapper);
                    // })
                    this.setRootFontSize(this.getUserDevice());

                });
            },
            postNotificationsSuccess (data) {
                if (data.data.unread) {
                    this.setUnreadInboxMessages(data.data.unread);
                }
            },
            getUserDevice () {
                const w = getViewPortWidth();
                let currentDevice = 'desktop';
                for (let [device, breakpoint] of Object.entries(this.deviceBreakpoints)) {
                    if (w <= breakpoint.maxWidth && w >= breakpoint.minWidth) {
                        currentDevice = device;
                    }
                }
                return currentDevice;
            },
            setRootFontSize (device) {
                const responsiveFontScale = this.responsiveFontScale;
                const baseFontSize = 10;
                let fontSize = baseFontSize * this.availableDevicePreviews[device]['fontScale'] / 100; // default value
                if (responsiveFontScale && responsiveFontScale[device]) {
                    fontSize = baseFontSize * responsiveFontScale[device] / 100;
                }

                //console.log('Setting font size to: ', fontSize);
                document.documentElement.style.setProperty('font-size', fontSize + 'px');
            },
        },
        components : {
            PreviewComponentsManager,
            PreviewSectionsManager,
            PopupNotifications,
            AdminNavigationTooltip,
            PreviewElementsManager,
            PreviewModeNotification
        }
    })



});
